import React from 'react';
import { useHistory } from 'react-router-dom';
import { ButtonContainer } from './styles';
import { Clock } from 'src/assets/Images';
import { Tooltip } from '@material-ui/core';
import { ROUTES } from 'src/Utils/constants';
import { getSearchParams } from 'src/Utils/getQueryParams';
export var TicketReminderButton = function (_a) {
    var ticketNumber = _a.ticketNumber;
    var history = useHistory();
    var handleClick = function (e) {
        e.stopPropagation();
        history.push(ROUTES.recordatorios_de_tickets + "?" + getSearchParams({
            ticket_number: ticketNumber,
        }));
    };
    return (React.createElement(Tooltip, { title: "Gestionar Recordatorios", arrow: true },
        React.createElement(ButtonContainer, { onClick: handleClick },
            React.createElement("img", { src: Clock, alt: "Recordatorios", width: "20", height: "20" }))));
};
